import React, { FC } from "react";
import { Field, useFormState } from "react-final-form";
import { Theme } from "@material-ui/core/styles";
import { makeStyles, Typography } from "@material-ui/core";
import BootstrapInput from "../BootstrapInput";
import FontIcon from "../FontIcon";
import ApplicationsCount from "../ApplicationsCount/ApplicationsCount";

const useStyles = makeStyles((theme: Theme) => ({
  mainText: {
    fontWeight: "bold",
    marginBottom: 16,
  },
  warningCnt: {
    display: "flex",
    columnGap: "10px",
    marginTop: 10,
    alignItems: "center",
    "& > p": {
      fontSize: 14,
      color: "#a1a4ac",
    },
  },
  warningIcon: {
    color: theme.palette.error.main,
    fontSize: 20,
  },
  defaultIcon: {
    color: "#a1a4ac",
    fontSize: 20,
  },
  reasonCnt: {
    height: 150,
  },
}));

interface DeactivateFormProps {
  name: string;
}

const DeactivateContent: FC<DeactivateFormProps> = ({ name }) => {
  const classes = useStyles();
  const {
    values: {
      injectedData: { approved, pending },
    },
  } = useFormState();
  const applicationsCount = +approved + +pending;
  const isReasonRequired = applicationsCount > 0;

  return (
    <form>
      <div>
        <Typography className={classes.mainText}>
          Are you sure you want to deactivate this {name}?
        </Typography>
        {isReasonRequired && (
          <div className={classes.reasonCnt}>
            <Field
              required={true}
              fullWidth
              type="text"
              label={`Deactivation reason`}
              placeholder="Please enter deactivation reason to inform student(s)"
              multiline={true}
              rows={5}
              component={BootstrapInput}
              name={"reason"}
            />
          </div>
        )}
        <ApplicationsCount name={name} approved={approved} pending={pending} />
        <div className={classes.warningCnt}>
          {isReasonRequired ? (
            <FontIcon name={"warning"} className={classes.warningIcon} />
          ) : (
            <FontIcon name={"info"} className={classes.defaultIcon} />
          )}
          <Typography>
            By deactivating this {name}, <strong>{applicationsCount}</strong>
            {applicationsCount === 1 ? " application" : " applications"} will be
            canceled
          </Typography>
        </div>
      </div>
    </form>
  );
};

export default DeactivateContent;
